import React from 'react';

import useBlueConicPersonalizedReadingHub from '@hooks/useBlueConicPersonalizedReadingHub';

import CommunityInsights from './CommunityInsights';
import DataTools from './DataTools';
import DeepResearch from './DeepResearch';
import MyTIHeader from './Header';
import Nav from './Nav';
import Newsletters from './Newsletters';
import OrgCharts from './OrgCharts';
import ReadingStats from './ReadingStats';
import RecommendedArticles from './RecommendedArticles';
import Reporters from './Reporters';
import Topics from './Topics';
import { MY_TI_COMPONENT_LIST, UserAccess } from './constants';
import type { MyTIContentProps } from './interfaces';

const COMPONENT_MAP: Record<string, React.ComponentType> = {
  CommunityInsights,
  DataTools,
  DeepResearch,
  Nav,
  Newsletters,
  OrgCharts,
  ReadingStats,
  RecommendedArticles,
  Reporters,
  Topics,
};

const MyTIContent = ({ forumPosts, initialCurrentUser, newsletterNames }: MyTIContentProps) => {
  const readingStats = useBlueConicPersonalizedReadingHub();

  const userAccess = initialCurrentUser?.is_pro_subscriber ? UserAccess.Pro : UserAccess.Annual;
  const components = MY_TI_COMPONENT_LIST[userAccess];
  const additionalProps = {
    forumPosts,
    initialCurrentUser,
    newsletterNames,
  };

  return (
    <main className="my-ti-container relative w-full px-16 sm:px-28">
      <div className="mx-auto flex w-full max-w-container-lg flex-col">
        <MyTIHeader initialCurrentUser={initialCurrentUser} />
        {components.map((name, index) => {
          const Component = COMPONENT_MAP[name];
          if (!Component) return null;
          const props = index === 0 ? { ...additionalProps, hideBorder: false } : additionalProps;

          return <Component key={name} {...props} {...readingStats} />;
        })}
      </div>
    </main>
  );
};

export default MyTIContent;
